import {createAction} from 'redux-actions';
import {getIngestReport} from '@pluto/rest';

export const INGEST_REPORT_SET = 'INGEST_REPORT_SET';
export const INGEST_REPORT_RESET = 'INGEST_REPORT_RESET';

export const setIngestReportAction = createAction(INGEST_REPORT_SET, async (id: any) => {
    return await getIngestReport(id);
});

export const resetIngestReportAction = createAction(INGEST_REPORT_RESET);
